import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'

import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { ValidateRegisterAction } from '../../../redux/actions/user'
import * as types from '../../../redux/constantes/user'

import { ContainerContent, ContainerTemplate } from '../../../components/Containers'
import { MessageBoxError, MessageBoxSuccess } from '../../../components/MessageBox'
import { InputUser } from '../../../components/User/InputUser'
import { ButtonSend } from '../../../components/ButtonSend'
import { Header } from '../../../components/User/Header'
import { Title } from '../../../components/User/Title'
import { ButtonRedirect } from '../../../components/ButtonRedirect'

export const TemplateValidation: React.FC = () => {
  const { loading, success, error } = useSelector((state: RootStateOrAny) => state.validateRegister)
  const dispatch = useDispatch()
  const history = useHistory()

  const [disableAllInputs, setDisableAllInputs] = useState(false)
  const [disableButton, setDisableButton] = useState(false)
  const [validateCode, setValidateCode] = useState(true)
  const [code, setCode] = useState('')

  const codeIsValid = () => {
    if (code === '') {
      setValidateCode(false)
    } else {
      setValidateCode(true)
    }
  }

  const fullValidations = () => {
    if (validateCode && code.length !== 0 && !disableButton) {
      return false
    } else {
      return true
    }
  }

  const onSubmit = () => {
    dispatch(ValidateRegisterAction(code))
    setDisableButton(true)
  }

  useEffect(() => {
    if (success) {
      setDisableAllInputs(true)
      setTimeout(() => {
        dispatch({ type: types.VALIDATE_REGISTER_RESET })
        history.push('/cadastro-realizado')
      }, 5000)
    }
    if (error) {
      setDisableButton(false)
      setTimeout(() => {
        dispatch({ type: types.VALIDATE_REGISTER_RESET })
      }, 5000)
    }
  }, [success, error])

  return (
    <ContainerTemplate>
      <Header />
      <ContainerContent>
        <Title text="Insira no campo abaixo o código de validação que foi enviado via SMS para seu celular, e assim finalizar o seu pré-cadastro" />
        <InputUser
          label={`Código de Validação ${!validateCode ? '(Campo obrigatório esta em branco ou incorreto)' : ''}`}
          onBlur={codeIsValid}
          onChange={e => setCode(e.target.value)}
          placeholder="exemplo: nGwsUxakKH"
          value={code}
          isValidate={validateCode}
          disabled={disableAllInputs}
        />
        {!loading ? (
          <>
            <ButtonSend nameButton="Validar código" disabled={fullValidations()} onClick={onSubmit} />
            <ButtonRedirect link="/verificar-validacao" nameButton="Re-enviar código" />
          </>
        ) : (
          <ButtonSend nameButton="Aguarde..." disabled={true} />
        )}
        {success && <MessageBoxSuccess>{success}</MessageBoxSuccess>}
        {error && <MessageBoxError>{error}</MessageBoxError>}
      </ContainerContent>
    </ContainerTemplate>
  )
}
